<div class="mia-config">

  <!-- Cabeçalho + abas: identidade, estado atual e navegação sempre visíveis -->
  <div class="mia-topo">
    <header class="mia-header" [attr.data-estado]="estadoAtual.chave">
      <div class="mia-header__identidade">
        <span class="mia-avatar"><i class="fas fa-robot"></i></span>
        <div>
          <h1 class="mia-header__titulo">
            {{ configuracoes.nome || 'Mia' }}
            <span class="mia-header__selo">Atendente Virtual WhatsApp</span>
          </h1>
          <p class="mia-header__sub">Gerencie o comportamento, modelo de IA e automações</p>
        </div>
      </div>

      <div class="mia-header__estado">
        <span class="mia-pill" [attr.data-estado]="estadoAtual.chave">
          <span class="mia-pill__dot"></span>{{ estadoAtual.rotulo }}
        </span>
        <button type="button" class="mia-link" (click)="mostrarRecursos = !mostrarRecursos"
                [attr.aria-expanded]="mostrarRecursos" aria-controls="mia-recursos">
          <i class="far fa-question-circle"></i>
          O que a Mia faz?
        </button>
      </div>
    </header>

    <nav class="mia-abas" role="tablist" aria-label="Seções da configuração da Mia">
      <button type="button" class="mia-aba-btn" role="tab" *ngFor="let aba of abas"
              [id]="'mia-aba-' + aba.chave"
              [class.mia-aba-btn--ativa]="abaAtiva === aba.chave"
              [class.mia-aba-btn--bloqueada]="aba.exigeMiaLigada && miaDesligada"
              [attr.aria-selected]="abaAtiva === aba.chave"
              [attr.aria-controls]="'mia-painel-' + aba.chave"
              [attr.title]="aba.exigeMiaLigada && miaDesligada ? 'Ligue a Mia em Status & Geral para configurar' : null"
              (click)="selecioneAba(aba.chave)">
        <i class="fas" [ngClass]="aba.icone"></i>
        <span>{{ aba.rotulo }}</span>
        <span class="mia-selo-aba" [class.mia-selo-aba--admin]="aba.selo === 'admin'"
              [class.mia-selo-aba--venda]="aba.chave === 'vendas'"
              *ngIf="aba.selo">{{ aba.selo }}</span>
      </button>
    </nav>
  </div>

  <!-- Lista de capacidades: ajuda, não vitrine. Fechada por padrão. -->
  <section class="mia-recursos" id="mia-recursos" *ngIf="mostrarRecursos">
    <p class="mia-recursos__intro">A Mia atende sozinha estas situações, direto no WhatsApp:</p>
    <ul class="mia-recursos__lista">
      <li><i class="fas fa-check"></i><span><strong>Estimula pedidos</strong> pelo cardápio digital, mesmo quando o cliente tenta pedir pelo WhatsApp.</span></li>
      <li><i class="fas fa-check"></i><span><strong>Envia o cardápio</strong> digital para o cliente.</span></li>
      <li><i class="fas fa-check"></i><span><strong>Informa</strong> sobre os itens disponíveis, sem o cliente sair da conversa.</span></li>
      <li><i class="fas fa-check"></i><span><strong>Consulta o status</strong> dos pedidos.</span></li>
      <li><i class="fas fa-check"></i><span><strong>Divulga promoções</strong>, cupons e ofertas especiais.</span></li>
      <li><i class="fas fa-check"></i><span><strong>Responde horários</strong> de funcionamento da loja.</span></li>
      <li><i class="fas fa-check"></i><span><strong>Informa o endereço</strong> da loja.</span></li>
      <li><i class="fas fa-check"></i><span><strong>Tira dúvidas</strong> dos clientes sobre o estabelecimento.</span></li>
      <li><i class="fas fa-check"></i><span><strong>Atende na hora</strong>, sem fila de espera, a qualquer momento do dia.</span></li>
    </ul>
  </section>

  <form [ngClass]="{'needs-validation': !frm.submitted, 'was-validated': frm.submitted}" (ngSubmit)="onSubmit()"
        novalidate #frm="ngForm">

    <!-- ABA 1. Status & Geral -->
    <div class="mia-painel-aba" id="mia-painel-status" role="tabpanel" aria-labelledby="mia-aba-status"
         [class.mia-painel-aba--oculta]="abaAtiva !== 'status'">

      <section class="mia-card">
        <div class="mia-card__head">
          <h2 class="mia-card__titulo"><span class="mia-card__icone"><i class="fas fa-power-off"></i></span> Status de Operação</h2>
          <p class="mia-card__desc">Escolha quem recebe e conversa com a Mia no WhatsApp.</p>
        </div>

        <div class="mia-modos">
          <label class="mia-modo" for="rbDesativada">
            <input type="radio" class="mia-modo__input" id="rbDesativada" name="estado-mia" value="DESATIVADA"
                   [(ngModel)]="configuracoes.status"/>
            <span class="mia-modo__corpo" data-estado="off">
              <span class="mia-modo__icone"><i class="fas fa-power-off"></i></span>
              <span class="mia-modo__nome">Desligada</span>
              <span class="mia-modo__desc">Ninguém recebe respostas automáticas da Mia. Atendimento fica 100% manual.</span>
              <span class="mia-modo__marca"><i class="fas fa-check"></i></span>
            </span>
          </label>

          <label class="mia-modo" for="rbModoTeste">
            <input type="radio" class="mia-modo__input" id="rbModoTeste" name="estado-mia" value="MODO_TESTE"
                   [(ngModel)]="configuracoes.status"/>
            <span class="mia-modo__corpo" data-estado="teste">
              <span class="mia-modo__icone"><i class="fas fa-flask"></i></span>
              <span class="mia-modo__nome">Modo Teste <span class="mia-modo__selo">Recomendado</span></span>
              <span class="mia-modo__desc">Apenas os números autorizados da lista de testes conversam com a Mia.</span>
              <span class="mia-modo__marca"><i class="fas fa-check"></i></span>
            </span>
          </label>

          <label class="mia-modo" for="rbAtivada">
            <input type="radio" class="mia-modo__input" id="rbAtivada" name="estado-mia" value="ATIVADA"
                   [(ngModel)]="configuracoes.status"/>
            <span class="mia-modo__corpo" data-estado="ativa">
              <span class="mia-modo__icone"><i class="fas fa-rocket"></i></span>
              <span class="mia-modo__nome">Em Produção</span>
              <span class="mia-modo__desc">Todos os clientes do seu estabelecimento são atendidos automaticamente pela Mia.</span>
              <span class="mia-modo__marca"><i class="fas fa-check"></i></span>
            </span>
          </label>
        </div>

        <div class="mia-painel" *ngIf="configuracoes.status === 'MODO_TESTE'">
          <div class="mia-painel__head">
            <h3 class="mia-painel__titulo">
              <i class="fas fa-phone-alt"></i> Telefones liberados para teste
            </h3>
            <span class="mia-painel__contador">{{ telefones.length }} número(s) cadastrado(s)</span>
          </div>
          <p class="mia-hint">Digite o número completo com código do país (DDI + DDD + Número). Sem espaços ou traços.</p>

          <div class="mia-fichas" *ngIf="telefones.length">
            <span class="mia-ficha" *ngFor="let telefone of telefones">
              {{ telefone }}
              <button type="button" class="mia-ficha__x" (click)="removaTelefone(telefone)"
                      [attr.aria-label]="'Remover ' + telefone">
                <i class="fas fa-times"></i>
              </button>
            </span>
          </div>

          <div class="mia-add">
            <input type="text" class="form-control" id="novo-telefone" name="novoTelefone"
                   [(ngModel)]="novoTelefone" [ngModelOptions]="{standalone: true}"
                   [placeholder]="exemploTelefone"
                   (keydown.enter)="$event.preventDefault(); adicioneTelefone()"/>
            <button type="button" class="mia-add__btn" (click)="adicioneTelefone()">
              <i class="fas fa-plus"></i> Adicionar
            </button>
          </div>
        </div>
      </section>

      <section class="mia-card">
        <div class="mia-card__head">
          <h2 class="mia-card__titulo"><span class="mia-card__icone"><i class="fas fa-user"></i></span> Identidade e Inteligência</h2>
          <p class="mia-card__desc">Defina o nome de apresentação e o motor de linguagem da IA.</p>
        </div>

        <div class="mia-grid">
          <div class="mia-campo">
            <label for="chatbot-name" class="mia-label mia-label--cap">Nome da atendente</label>
            <input type="text" class="form-control" id="chatbot-name" name="Mia" kendoTextBox #nome="ngModel"
                   [(ngModel)]="configuracoes.nome" required="true" minlength="3"/>
            <p class="mia-hint">Nome exibido na saudação inicial (Ex: "Olá! Sou a Mia, atendente do estabelecimento").</p>
            <div class="invalid-feedback">
              <span *ngIf="nome.errors?.required">Informe o nome da Mia.</span>
              <span *ngIf="nome.errors?.minlength">Use pelo menos 3 letras no nome da Mia.</span>
            </div>
          </div>

        </div>
      </section>

    </div>

    <!-- ABA 2. Comportamento: três grupos por assunto, cada um abre e fecha. Dentro de
         cada um o ajuste que governa os outros vem antes deles, e não depois. -->
    <div class="mia-painel-aba mia-ajustes" id="mia-painel-comportamento" role="tabpanel"
         aria-labelledby="mia-aba-comportamento"
         [class.mia-painel-aba--oculta]="abaAtiva !== 'comportamento'">

      <!-- Grupo 1: quando a Mia sai de cena. O toggle mestre vem primeiro porque
           governa o aviso, a pausa e a opção "chamar atendente" dos outros blocos. -->
      <section class="mia-grupo" data-cor="humano">
        <button type="button" class="mia-grupo__head" (click)="alterneGrupo('humano')"
                [attr.aria-expanded]="gruposComportamento.humano" aria-controls="mia-grupo-humano">
          <span class="mia-grupo__badge"><i class="fas fa-headset"></i></span>
          <span class="mia-grupo__txt">
            <span class="mia-grupo__titulo">Atendimento humano</span>
            <span class="mia-grupo__desc" *ngIf="gruposComportamento.humano">Quando a Mia sai de cena e alguém do time assume.</span>
            <span class="mia-grupo__resumo" *ngIf="!gruposComportamento.humano">{{ resumoAtendimentoHumano }}</span>
          </span>
          <i class="fas fa-chevron-down mia-grupo__chevron"></i>
        </button>

        <div class="mia-grupo__corpo" id="mia-grupo-humano"
             [class.mia-grupo__corpo--fechado]="!gruposComportamento.humano">

          <div class="mia-linha mia-linha--limpa">
            <div class="mia-linha__texto">
              <label for="escalarParaAtendente" class="mia-label"><i class="fas fa-headset"></i> Deixar a Mia chamar uma pessoa da equipe</label>
              <p class="mia-hint">Quando o cliente pede para falar com um atendente, reclama de um pedido ou a Mia trava, a conversa vai
                para a tela de conversas e alguém do time assume. Desligue se não há ninguém acompanhando o painel — assim a Mia
                nunca promete um atendente que não vem.</p>
            </div>
            <kendo-switch id="escalarParaAtendente" name="escalarParaAtendente"
                          [(ngModel)]="configuracoes.escalarParaAtendente"
                          [onLabel]="'Sim'" [offLabel]="'Não'"></kendo-switch>
          </div>

          <!-- só existem por causa do toggle acima: ficam recuados sob ele -->
          <div class="mia-filhos" *ngIf="configuracoes.escalarParaAtendente">
            <div>
              <label for="mensagemEscalacao" class="mia-label">Aviso ao cliente (opcional)</label>
              <p class="mia-hint">O que o cliente recebe no momento em que a conversa é passada para a equipe. Deixe em branco
                para a Mia avisar com as palavras dela. Evite prometer prazo: ninguém sabe quando alguém vai assumir.</p>
              <textarea class="form-control" id="mensagemEscalacao" name="mensagemEscalacao" rows="2" maxlength="500"
                        [(ngModel)]="configuracoes.mensagemEscalacao"
                        placeholder="Ex.: Já passei sua mensagem para nossa equipe, alguém continua seu atendimento por aqui."></textarea>
            </div>

            <div>
              <div class="mia-linha">
                <div class="mia-linha__texto">
                  <label for="tempoDePausaMia" class="mia-label">Tempo de pausa</label>
                  <p class="mia-hint">Quanto tempo a Mia fica em silêncio depois de chamar um atendente humano, para não atrapalhar o time.</p>
                </div>
                <div class="mia-numero">
                  <input type="number" class="form-control" id="tempoDePausaMia" name="tempoDePausaMia" kendoNumericTextBox
                         #tempoDePausaMia="ngModel" [(ngModel)]="configuracoes.tempoPausaMia" required="true" min="1"
                         maxlength="6" aria-describedby="tempoDePausaMiaEco"/>
                  <span class="mia-numero__sufixo">segundos</span>
                </div>
              </div>
              <p class="mia-eco" id="tempoDePausaMiaEco">
                <i class="far fa-clock"></i> A Mia fica <strong>{{ formatTime(configuracoes.tempoPausaMia) }}</strong> em silêncio após chamar o atendente.
              </p>
              <div class="mia-erro" *ngIf="frm.submitted || tempoDePausaMia.touched">
                <span *ngIf="tempoDePausaMia.errors?.required">Informe o tempo de pausa.</span>
                <span *ngIf="tempoDePausaMia.errors?.min">Use um tempo de pausa de pelo menos 1 segundo.</span>
              </div>
            </div>
          </div>

          <div class="mia-corte"></div>

          <fieldset class="mia-opcoes">
            <legend class="mia-label"><i class="fas fa-question-circle mia-opcoes__icone"></i> Perguntas fora do escopo</legend>
            <p class="mia-hint mia-hint--escolha">O que a Mia faz quando perguntam algo que não é do atendimento.</p>

            <div class="mia-chips">
              <label class="mia-opcao mia-opcao--chip" *ngFor="let opcao of opcoesForaDoEscopo">
                <input type="radio" class="mia-opcao__input" [id]="'rbEscopo' + opcao.valor"
                       name="comportamentoForaDoEscopo" [value]="opcao.valor"
                       [(ngModel)]="configuracoes.comportamentoForaDoEscopo"/>
                <span class="mia-opcao__corpo">
                  <span class="mia-opcao__marca"></span>
                  <span>
                    <span class="mia-opcao__nome"><i class="fas" [ngClass]="opcao.icone"></i> {{ opcao.nome }}</span>
                    <span class="mia-opcao__desc">{{ opcao.descricao }}<strong *ngIf="opcao.reforco"> {{ opcao.reforco }}</strong></span>
                  </span>
                </span>
                <span class="mia-dica" role="tooltip">{{ dicaDaOpcao(opcao) }}</span>
              </label>
            </div>

            <p class="mia-escolhido" *ngIf="opcaoForaDoEscopo">
              <span>{{ opcaoForaDoEscopo.descricao }}<strong *ngIf="opcaoForaDoEscopo.reforco"> {{ opcaoForaDoEscopo.reforco }}</strong></span>
            </p>
          </fieldset>
        </div>
      </section>

      <!-- Grupo 2: imagem. Áudio saiu daqui e virou a aba "Ouvir": é a única
           capacidade da tela com custo por uso, e um dia será cobrada à parte. -->
      <section class="mia-grupo" data-cor="imagens">
        <button type="button" class="mia-grupo__head" (click)="alterneGrupo('imagens')"
                [attr.aria-expanded]="gruposComportamento.imagens" aria-controls="mia-grupo-imagens">
          <span class="mia-grupo__badge"><i class="fas fa-image"></i></span>
          <span class="mia-grupo__txt">
            <span class="mia-grupo__titulo">Imagens do cliente</span>
            <span class="mia-grupo__desc" *ngIf="gruposComportamento.imagens">O que a Mia faz com as fotos que o cliente manda.</span>
            <span class="mia-grupo__resumo" *ngIf="!gruposComportamento.imagens">{{ resumoImagens }}</span>
          </span>
          <i class="fas fa-chevron-down mia-grupo__chevron"></i>
        </button>

        <div class="mia-grupo__corpo" id="mia-grupo-imagens"
             [class.mia-grupo__corpo--fechado]="!gruposComportamento.imagens">

          <div class="mia-linha mia-linha--limpa">
            <div class="mia-linha__texto">
              <label for="entenderImagens" class="mia-label"><i class="fas fa-image"></i> Entender as imagens do cliente</label>
              <p class="mia-hint">A Mia lê a imagem que o cliente manda (foto de um produto, print, comprovante) e
                responde sobre ela. Desligado, a imagem continua aparecendo na conversa do painel para a sua equipe,
                mas a Mia não tenta interpretar o conteúdo.</p>
            </div>
            <kendo-switch id="entenderImagens" name="entenderImagens"
                          [(ngModel)]="configuracoes.entenderImagens"
                          [onLabel]="'Sim'" [offLabel]="'Não'"></kendo-switch>
          </div>

          <!-- quem vier procurar áudio aqui precisa achar o caminho -->
          <p class="mia-atalho">
            <i class="fas fa-microphone"></i>
            <span>O que a Mia faz com os áudios agora fica na aba Ouvir.</span>
            <button type="button" class="mia-atalho__link" (click)="selecioneAba('ouvir')">Ir para Ouvir</button>
          </p>
        </div>
      </section>

      <!-- Grupo 3: como a Mia mostra o cardápio e fecha o pedido -->
      <section class="mia-grupo" data-cor="cardapio">
        <button type="button" class="mia-grupo__head" (click)="alterneGrupo('cardapio')"
                [attr.aria-expanded]="gruposComportamento.cardapio" aria-controls="mia-grupo-cardapio">
          <span class="mia-grupo__badge"><i class="fas fa-utensils"></i></span>
          <span class="mia-grupo__txt">
            <span class="mia-grupo__titulo">Cardápio e fechamento</span>
            <span class="mia-grupo__desc" *ngIf="gruposComportamento.cardapio">Como a Mia mostra o cardápio e fecha o pedido.</span>
            <span class="mia-grupo__resumo" *ngIf="!gruposComportamento.cardapio">{{ resumoCardapio }}</span>
          </span>
          <i class="fas fa-chevron-down mia-grupo__chevron"></i>
        </button>

        <div class="mia-grupo__corpo" id="mia-grupo-cardapio"
             [class.mia-grupo__corpo--fechado]="!gruposComportamento.cardapio">

          <div class="mia-linha mia-linha--limpa">
            <div class="mia-linha__texto">
              <label for="responderSobreProdutos" class="mia-label"><i class="fas fa-utensils"></i> Responder sobre produtos do cardápio</label>
              <p class="mia-hint">A Mia usa o cardápio para falar de itens, preços e disponibilidade.</p>
            </div>
            <kendo-switch id="responderSobreProdutos" name="responderSobreProdutos"
                          [(ngModel)]="configuracoes.responderSobreProdutos"
                          [onLabel]="'Sim'" [offLabel]="'Não'"></kendo-switch>
          </div>

          <div class="mia-corte"></div>

          <div class="mia-linha">
            <div class="mia-linha__texto">
              <label for="divulgarLinkCardapio" class="mia-label"><i class="fas fa-link"></i> Divulgar o link do cardápio</label>
              <p class="mia-hint">A Mia envia o link do cardápio digital já na primeira vez que o cliente quer ver o
                cardápio, junto das categorias — e a saudação menciona esse caminho. Desligado, o link só vai quando o
                cliente pede explicitamente.</p>
            </div>
            <kendo-switch id="divulgarLinkCardapio" name="divulgarLinkCardapio"
                          [(ngModel)]="configuracoes.divulgarLinkCardapio"
                          [onLabel]="'Sim'" [offLabel]="'Não'"></kendo-switch>
          </div>

          <!-- aparência do botão que a Mia manda junto do link -->
          <div class="mia-filhos">
            <div>
              <label for="rotuloBotaoCardapio" class="mia-label mia-label--contada">
                <span>Texto do botão do cardápio (opcional)</span>
                <span class="mia-contador">{{ (configuracoes.rotuloBotaoCardapio || '').length }}/20</span>
              </label>
              <p class="mia-hint">Texto do botão que abre o cardápio online nas mensagens da Mia. Em branco vale o
                padrão "Fazer Pedido". Máximo de 20 caracteres (limite do WhatsApp).</p>
              <input type="text" class="form-control" id="rotuloBotaoCardapio" name="rotuloBotaoCardapio" maxlength="20"
                     [(ngModel)]="configuracoes.rotuloBotaoCardapio" placeholder="Fazer Pedido"/>
            </div>
            <div>
              <label for="rodapeBotaoCardapio" class="mia-label mia-label--contada">
                <span>Frase de apoio do botão (opcional)</span>
                <span class="mia-contador">{{ (configuracoes.rodapeBotaoCardapio || '').length }}/60</span>
              </label>
              <p class="mia-hint">Frase pequena que aparece entre o texto da mensagem e o botão. Em branco vale o
                padrão "Toque no botão para fazer seu pedido". Máximo de 60 caracteres.</p>
              <input type="text" class="form-control" id="rodapeBotaoCardapio" name="rodapeBotaoCardapio" maxlength="60"
                     [(ngModel)]="configuracoes.rodapeBotaoCardapio" placeholder="Toque no botão para fazer seu pedido"/>
            </div>
          </div>

          <div class="mia-corte"></div>

          <div class="mia-linha">
            <div class="mia-linha__texto">
              <label for="pedirLocalizacao" class="mia-label"><i class="fas fa-map-marker-alt"></i> Pedir a localização no delivery</label>
              <p class="mia-hint">No fechamento com entrega, a Mia pede a localização 📍 do cliente para montar o
                endereço. Desligado, ela pede o endereço digitado (rua, número e bairro). Se o cliente mandar a
                localização por conta própria, ela continua sendo aproveitada.</p>
            </div>
            <kendo-switch id="pedirLocalizacao" name="pedirLocalizacao"
                          [(ngModel)]="configuracoes.pedirLocalizacao"
                          [onLabel]="'Sim'" [offLabel]="'Não'"></kendo-switch>
          </div>
        </div>
      </section>

    </div>

    <!-- ABA 3. Ouvir: a única capacidade da tela que consome por uso (STT). Ganhou
         aba própria porque recurso cobrado precisa de superfície própria — quando a
         cobrança existir, entra aqui a faixa de consumo e a aba passa a ser filtrada
         por um `exigeRecurso` em `get abas()`, no mesmo molde de Empresa.temRecurso. -->
    <div class="mia-painel-aba" id="mia-painel-ouvir" role="tabpanel" aria-labelledby="mia-aba-ouvir"
         [class.mia-painel-aba--oculta]="abaAtiva !== 'ouvir'">

      <section class="mia-card mia-ajustes">
        <div class="mia-card__head">
          <h2 class="mia-card__titulo">
            <span class="mia-card__icone mia-card__icone--ouvir"><i class="fas fa-microphone"></i></span> Ouvir
          </h2>
          <p class="mia-card__desc">O que a Mia faz com os áudios que o cliente manda.</p>
        </div>

        <fieldset class="mia-opcoes">
          <legend class="mia-label">Quando o cliente manda áudio</legend>
          <p class="mia-hint mia-hint--escolha">Escolha o que a Mia faz quando um áudio chegar.</p>

          <div class="mia-chips">
            <label class="mia-opcao mia-opcao--chip" *ngFor="let opcao of opcoesAudio">
              <input type="radio" class="mia-opcao__input" [id]="'rbAudio' + opcao.valor"
                     name="comportamentoAudio" [value]="opcao.valor"
                     [(ngModel)]="configuracoes.comportamentoAudio"/>
              <span class="mia-opcao__corpo">
                <span class="mia-opcao__marca"></span>
                <span>
                  <span class="mia-opcao__nome"><i class="fas" [ngClass]="opcao.icone"></i> {{ opcao.nome }}</span>
                  <span class="mia-opcao__desc">{{ opcao.descricao }}<strong *ngIf="opcao.reforco"> {{ opcao.reforco }}</strong></span>
                </span>
              </span>
              <span class="mia-dica" role="tooltip">{{ dicaDaOpcao(opcao) }}</span>
            </label>
          </div>

          <p class="mia-escolhido" *ngIf="opcaoAudio">
            <span>{{ opcaoAudio.descricao }}<strong *ngIf="opcaoAudio.reforco"> {{ opcaoAudio.reforco }}</strong></span>
          </p>

          <!-- o aviso fala de um toggle que mora em Comportamento: sem o atalho ele
               manda o lojista procurar um ajuste que não está nesta tela -->
          <p class="mia-aviso" *ngIf="!configuracoes.escalarParaAtendente">
            <i class="fas fa-info-circle"></i>
            <span>Com "Deixar a Mia chamar uma pessoa da equipe" desligado, não há para onde passar a conversa: a Mia
              apenas pede o texto e nunca chama um atendente.
              <button type="button" class="mia-atalho__link" (click)="selecioneAba('comportamento')">Ver em Comportamento</button></span>
          </p>
        </fieldset>
      </section>

    </div>


    <!-- ABA 4. Vendas: a aba inteira só existe com o carrinho conversacional ligado -->
    <div class="mia-painel-aba" id="mia-painel-vendas" role="tabpanel" aria-labelledby="mia-aba-vendas"
         *ngIf="configuracoes.carrinhoMiaV3" [class.mia-painel-aba--oculta]="abaAtiva !== 'vendas'">

      <section class="mia-card mia-card--destaque">
        <div class="mia-card__head">
          <h2 class="mia-card__titulo">
            <span class="mia-card__icone mia-card__icone--venda"><i class="fas fa-gift"></i></span>
            Aumentar o ticket
            <span class="mia-selo-venda">vende mais</span>
            <span class="mia-card__estado" *ngIf="configuracoes.upsellFechamento">
              {{ produtosUpsell.length ? produtosUpsell.length + ' de 3 itens escolhidos' : 'modo automático' }}
            </span>
          </h2>
          <p class="mia-card__desc">Na hora de fechar o pedido, a Mia oferece um item a mais — uma única vez, sem insistir.</p>
        </div>

        <div class="mia-linha">
          <div class="mia-linha__texto">
            <label for="upsellFechamento" class="mia-label"><i class="fas fa-plus-circle"></i> Oferecer um item a mais antes de fechar</label>
            <p class="mia-hint">Antes de perguntar entrega ou retirada, a Mia sugere um item que combina com o pedido.
              Se o cliente aceitar, o item entra direto no carrinho com o preço do cardápio.</p>
          </div>
          <kendo-switch id="upsellFechamento" name="upsellFechamento"
                        [(ngModel)]="configuracoes.upsellFechamento"
                        [onLabel]="'Sim'" [offLabel]="'Não'"></kendo-switch>
        </div>

        <ng-container *ngIf="configuracoes.upsellFechamento">
          <div class="mia-painel upsell-painel">
            <div class="upsell-escolha">
              <div class="mia-linha__texto">
                <label for="produtoUpsell" class="mia-label"><i class="fas fa-list-ul"></i> Itens que a Mia vai sugerir</label>
                <p class="mia-hint">Escolha até 3 itens, na ordem em que a Mia deve preferir. Sem itens escolhidos,
                  ela decide sozinha: sugere o que os seus clientes mais pedem junto, com base nos pedidos dos últimos meses.</p>
              </div>
              <kendo-dropdownlist id="produtoUpsell" name="produtoUpsell" class="form-control upsell-busca"
                                  [data]="opcoesBuscaUpsell"
                                  [filterable]="true"
                                  [textField]="'descricao'" [valueField]="'id'"
                                  [disabled]="produtosUpsell.length >= 3"
                                  [(ngModel)]="produtoUpsellSelecionado"
                                  [defaultItem]="{id: null, descricao: produtosUpsell.length >= 3 ? 'Limite de 3 itens — remova um para trocar' : 'Buscar item do cardápio...'}"
                                  (valueChange)="adicioneProdutoUpsell($event)"
                                  (filterChange)="searchProdutoUpsell($event)"
                                  (focus)="busquePrimeiraVezUpsell()">
              </kendo-dropdownlist>
            </div>

            <div class="upsell-cards" *ngIf="produtosUpsell.length; else upsellVazio">
              <div class="upsell-card" *ngFor="let produto of produtosUpsell; let i = index"
                   [class.upsell-card--inelegivel]="produto.elegivel === false">
                <span class="upsell-card__prioridade" title="Ordem de preferência">{{ i + 1 }}º</span>
                <img class="upsell-card__foto" *ngIf="produto.imagem" [src]="produto.imagem" alt=""/>
                <span class="upsell-card__foto upsell-card__foto--vazia" *ngIf="!produto.imagem" aria-hidden="true">
                  <i class="fas fa-utensils"></i>
                </span>
                <div class="upsell-card__info">
                  <strong class="upsell-card__nome">{{ produto.nome }}</strong>
                  <span class="upsell-card__meta">
                    <span class="upsell-card__preco" *ngIf="formatePrecoUpsell(produto.preco)">{{ formatePrecoUpsell(produto.preco) }}</span>
                    <span class="upsell-card__categoria" *ngIf="produto.categoria">{{ produto.categoria }}</span>
                  </span>
                  <span class="upsell-card__aviso" *ngIf="produto.elegivel === false">
                    <i class="fas fa-exclamation-triangle"></i>
                    Este item exige escolhas (tamanho ou adicionais) e será pulado — a oferta precisa caber em um toque.
                  </span>
                </div>
                <div class="upsell-card__acoes">
                  <button type="button" class="upsell-card__botao" *ngIf="i > 0"
                          (click)="subaPrioridadeUpsell(i)"
                          [attr.aria-label]="'Aumentar prioridade de ' + produto.nome">
                    <i class="fas fa-arrow-up"></i>
                  </button>
                  <button type="button" class="upsell-card__botao upsell-card__botao--remover"
                          (click)="removaProdutoUpsell(produto)"
                          [attr.aria-label]="'Remover ' + produto.nome">
                    <i class="fas fa-times"></i>
                  </button>
                </div>
              </div>
            </div>
            <ng-template #upsellVazio>
              <div class="upsell-vazio">
                <span class="upsell-vazio__icone" aria-hidden="true"><i class="fas fa-magic"></i></span>
                <div>
                  <strong class="upsell-vazio__titulo">Modo automático ligado</strong>
                  <p class="upsell-vazio__texto">A Mia analisa o que os seus clientes costumam pedir junto e sugere o
                    complemento com mais chance de agradar. Loja nova sem histórico? Ela oferece uma bebida ou
                    sobremesa que ainda não está no pedido.</p>
                </div>
              </div>
            </ng-template>

            <div class="upsell-preview" aria-hidden="true">
              <p class="upsell-preview__rotulo"><i class="fab fa-whatsapp"></i> Como o cliente vê</p>
              <div class="upsell-preview__chat">
                <div class="upsell-preview__bolha">
                  <p class="upsell-preview__texto">Boa escolha! 😄 Que tal um <b>{{ exemploUpsell.nome }}</b> ({{ exemploUpsell.preco }}) pra acompanhar?</p>
                  <div class="upsell-preview__botoes">
                    <span class="upsell-preview__botao">Adicionar · {{ exemploUpsell.preco }}</span>
                    <span class="upsell-preview__botao">Não, só isso</span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </ng-container>
      </section>

      <section class="mia-card mia-card--destaque">
        <div class="mia-card__head">
          <h2 class="mia-card__titulo">
            <span class="mia-card__icone mia-card__icone--venda"><i class="fas fa-comment-dots"></i></span>
            Recuperar conversas paradas
            <span class="mia-selo-venda">recupera vendas</span>
          </h2>
          <p class="mia-card__desc">A Mia retoma automaticamente a conversa quando o cliente some no meio da compra.</p>
        </div>

        <div class="mia-linha">
          <div class="mia-linha__texto">
            <label for="followupMiaV3" class="mia-label"><i class="fas fa-bell"></i> Enviar lembretes proativos</label>
            <p class="mia-hint">A mensagem só sai com a Mia ativa, a loja recebendo pedidos e nenhuma resposta ou pedido novo.</p>
          </div>
          <kendo-switch id="followupMiaV3" name="followupMiaV3"
                        [(ngModel)]="configuracoes.followupMiaV3"
                        [onLabel]="'Sim'" [offLabel]="'Não'"></kendo-switch>
        </div>

        <ng-container *ngIf="configuracoes.followupMiaV3">
          <div class="mia-painel">
            <div class="mia-linha mia-linha--empilha mia-linha--limpa">
              <div class="mia-linha__texto">
                <label class="mia-label"><i class="far fa-clock"></i> Toques do pedido parado</label>
                <p class="mia-hint">Cliente que montou o pedido e sumiu recebe até 3 lembretes, contados de quando ele
                  parou de responder: o resumo com botões, um empurrãozinho com botão de fechar e um último aviso que
                  encerra de leve.</p>
              </div>
            </div>
            <div class="mia-toques">
              <ng-container *ngFor="let toque of toquesCarrinho; let i = index; trackBy: trackPorIndice">
                <span class="mia-toques__seta" *ngIf="i > 0"><i class="fas fa-arrow-right"></i></span>
                <div class="mia-toques__chip">
                  <input type="number" class="form-control" [name]="'toqueCarrinho' + i" kendoNumericTextBox
                         [(ngModel)]="toquesCarrinho[i]" required="true" [min]="1" [max]="60"/>
                  <span class="mia-numero__sufixo">min</span>
                  <button type="button" class="mia-toques__remover" *ngIf="toquesCarrinho.length > 1"
                          (click)="removaToque(toquesCarrinho, i)" title="Remover este toque">&times;</button>
                </div>
              </ng-container>
              <button type="button" class="mia-toques__adicionar" *ngIf="toquesCarrinho.length < 3"
                      (click)="adicioneToque(toquesCarrinho)">+ adicionar toque</button>
            </div>
            <div class="mia-erro" *ngIf="!escadaValida(toquesCarrinho)">
              <span>Use tempos crescentes entre 1 e 60 minutos.</span>
            </div>
            <div class="upsell-preview" aria-hidden="true">
              <p class="upsell-preview__rotulo"><i class="fab fa-whatsapp"></i> Como o cliente vê</p>
              <div class="upsell-preview__chat mia-thread">
                <ng-container *ngFor="let toque of toquesCarrinho; let i = index; trackBy: trackPorIndice">
                  <p class="mia-thread__marcador">{{ marcadorDoToque(toquesCarrinho, i) }}</p>
                  <div class="upsell-preview__bolha">
                    <ng-container *ngIf="i === 0; else textoDoToqueCarrinho">
                      <p class="upsell-preview__texto">Oi! Seu pedido ficou quase pronto aqui 😊<br><b>Total: R$ 38,00</b><br>Quer fechar?</p>
                      <div class="upsell-preview__botoes">
                        <span class="upsell-preview__botao">Fechar pedido ✅</span>
                        <span class="upsell-preview__botao">Adicionar mais</span>
                      </div>
                    </ng-container>
                    <ng-template #textoDoToqueCarrinho>
                      <p class="upsell-preview__texto">{{ previewToquesCarrinho[i] }}</p>
                      <div class="upsell-preview__botoes" *ngIf="i === 1">
                        <span class="upsell-preview__botao">Fechar pedido ✅</span>
                      </div>
                    </ng-template>
                  </div>
                </ng-container>
              </div>
            </div>
            <div class="mia-linha mia-linha--empilha mia-linha--limpa mia-toques__separador">
              <div class="mia-linha__texto">
                <label class="mia-label"><i class="far fa-comment"></i> Toques da conversa</label>
                <p class="mia-hint">Cliente que só conversou, sem itens no carrinho, recebe toques mais leves — e menos
                  insistentes.</p>
              </div>
            </div>
            <div class="mia-toques">
              <ng-container *ngFor="let toque of toquesDescoberta; let i = index; trackBy: trackPorIndice">
                <span class="mia-toques__seta" *ngIf="i > 0"><i class="fas fa-arrow-right"></i></span>
                <div class="mia-toques__chip">
                  <input type="number" class="form-control" [name]="'toqueDescoberta' + i" kendoNumericTextBox
                         [(ngModel)]="toquesDescoberta[i]" required="true" [min]="1" [max]="60"/>
                  <span class="mia-numero__sufixo">min</span>
                  <button type="button" class="mia-toques__remover" *ngIf="toquesDescoberta.length > 1"
                          (click)="removaToque(toquesDescoberta, i)" title="Remover este toque">&times;</button>
                </div>
              </ng-container>
              <button type="button" class="mia-toques__adicionar" *ngIf="toquesDescoberta.length < 3"
                      (click)="adicioneToque(toquesDescoberta)">+ adicionar toque</button>
            </div>
            <div class="mia-erro" *ngIf="!escadaValida(toquesDescoberta)">
              <span>Use tempos crescentes entre 1 e 60 minutos.</span>
            </div>
            <div class="upsell-preview" aria-hidden="true">
              <p class="upsell-preview__rotulo"><i class="fab fa-whatsapp"></i> Como o cliente vê</p>
              <div class="upsell-preview__chat mia-thread">
                <ng-container *ngFor="let toque of toquesDescoberta; let i = index; trackBy: trackPorIndice">
                  <p class="mia-thread__marcador">{{ marcadorDoToque(toquesDescoberta, i) }}</p>
                  <div class="upsell-preview__bolha">
                    <p class="upsell-preview__texto">{{ previewToquesConversa[i] }}</p>
                  </div>
                </ng-container>
              </div>
            </div>
          </div>
        </ng-container>
      </section>
    </div>

    <!-- ABA 5. Recuperação de Carrinho -->
    <div class="mia-painel-aba" id="mia-painel-carrinho" role="tabpanel" aria-labelledby="mia-aba-carrinho"
         [class.mia-painel-aba--oculta]="abaAtiva !== 'carrinho'">
      <section class="mia-card">
        <div class="mia-card__head">
          <h2 class="mia-card__titulo"><span class="mia-card__icone"><i class="fas fa-shopping-basket"></i></span> Recuperação de carrinho</h2>
          <p class="mia-card__desc">Um lembrete para quem montou o pedido e não finalizou.</p>
        </div>

        <div class="mia-linha">
          <div class="mia-linha__texto">
            <label for="recuperarCarrinho" class="mia-label"><i class="fas fa-bell"></i> Lembrar cliente do carrinho abandonado</label>
            <p class="mia-hint">A Mia manda uma mensagem depois do tempo que você definir, para trazer o cliente de volta.</p>
          </div>
          <kendo-switch id="recuperarCarrinho" name="recuperarCarrinho" [(ngModel)]="configuracoes.recuperarCarrinho"
                        [onLabel]="'Sim'" [offLabel]="'Não'"></kendo-switch>
        </div>

        <ng-container *ngIf="configuracoes.recuperarCarrinho">
          <div class="mia-painel">
            <div class="mia-linha mia-linha--empilha mia-linha--limpa">
              <div class="mia-linha__texto">
                <label for="tempoRecuperarCarrinho" class="mia-label"><i class="fas fa-hourglass-half"></i> Esperar antes de enviar</label>
                <p class="mia-hint">Tempo suficiente para o cliente decidir, curto o bastante para não perder a oportunidade.</p>
              </div>
              <div class="mia-numero">
                <input type="number" class="form-control" id="tempoRecuperarCarrinho" name="tempoRecuperarCarrinho"
                       kendoNumericTextBox #tempoRecuperarCarrinho="ngModel"
                       [(ngModel)]="configuracoes.tempoRecuperarCarrinho" required="true" min="1" maxlength="6"
                       aria-describedby="tempoRecuperarCarrinhoEco"/>
                <span class="mia-numero__sufixo">segundos</span>
              </div>
            </div>
            <p class="mia-eco" id="tempoRecuperarCarrinhoEco">
              <i class="far fa-clock"></i> A mensagem sai <strong>{{ formatTime(configuracoes.tempoRecuperarCarrinho) }}</strong> depois do carrinho parado.
            </p>
            <div class="mia-erro" *ngIf="frm.submitted || tempoRecuperarCarrinho.touched">
              <span *ngIf="tempoRecuperarCarrinho.errors?.required">Informe o tempo de espera.</span>
              <span *ngIf="tempoRecuperarCarrinho.errors?.min">Use um tempo de espera de pelo menos 1 segundo.</span>
            </div>
          </div>

          <div class="mia-subsecao">
            <h3 class="mia-subsecao__titulo">Mensagem enviada</h3>
            <app-form-notificacao [notificacao]="notificacao"></app-form-notificacao>
          </div>
        </ng-container>
      </section>
    </div>

    <!-- Fluxo de Conversas: fora da navegação temporariamente. O painel fica aqui,
         sem aba que leve até ele, para a configuração continuar salvando intacta.
         Para devolver, basta reinserir a aba 'fluxo' em todasAbas no componente. -->
    <div class="mia-painel-aba" id="mia-painel-fluxo" role="tabpanel" aria-labelledby="mia-aba-fluxo"
         [class.mia-painel-aba--oculta]="abaAtiva !== 'fluxo'">
      <section class="mia-card">
        <div class="mia-card__head">
          <h2 class="mia-card__titulo"><span class="mia-card__icone"><i class="fas fa-layer-group"></i></span> Fluxo de conversas</h2>
          <p class="mia-card__desc">Um menu guiado antes da Mia assumir a conversa.</p>
        </div>

        <div class="mia-linha">
          <div class="mia-linha__texto">
            <label for="usarFluxoTypebot" class="mia-label"><i class="fas fa-project-diagram"></i> Usar fluxo de conversas</label>
            <p class="mia-hint">O cliente escolhe o que quer em um menu e a Mia continua a partir dali.</p>
          </div>
          <kendo-switch id="usarFluxoTypebot" name="usarFluxoTypebot" [(ngModel)]="configuracoes.usarFluxoTypebot"
                        [onLabel]="'Sim'" [offLabel]="'Não'"
                        (valueChange)="onUsarFluxoTypebotChange($event)"></kendo-switch>
        </div>

        <ng-container *ngIf="configuracoes.usarFluxoTypebot">
          <button type="button" class="mia-link mia-link--bloco" (click)="mostrarFluxoPadrao = !mostrarFluxoPadrao"
                  [attr.aria-expanded]="mostrarFluxoPadrao" aria-controls="mia-fluxo-padrao">
            Como funciona o fluxo padrão
            <i class="fas" [ngClass]="mostrarFluxoPadrao ? 'fa-chevron-up' : 'fa-chevron-down'"></i>
          </button>

          <div class="mia-painel mia-fluxo" id="mia-fluxo-padrao" *ngIf="mostrarFluxoPadrao">
            <p class="mia-hint">A conversa abre com quatro opções:</p>
            <ul class="mia-fluxo__menu">
              <li><span class="mia-fluxo__emoji">🛍️</span><strong>Fazer pedido</strong> — inicia um pedido e coleta os dados.</li>
              <li><span class="mia-fluxo__emoji">📱</span><strong>Ver cardápio</strong> — leva o cliente ao cardápio digital.</li>
              <li><span class="mia-fluxo__emoji">❓</span><strong>Tirar dúvida</strong> — responde as perguntas frequentes.</li>
              <li><span class="mia-fluxo__emoji">👤</span><strong>Falar com atendente</strong> — chama uma pessoa da equipe.</li>
            </ul>

            <p class="mia-fluxo__legenda">Ao escolher "Fazer pedido", a Mia segue esta ordem:</p>
            <ol class="mia-fluxo__etapas">
              <li>
                <span class="mia-fluxo__num">1</span>
                <span><strong>Forma de entrega</strong><small>Entrega ou retirada</small></span>
              </li>
              <li>
                <span class="mia-fluxo__num">2</span>
                <span><strong>Localização</strong><small>Endereço de entrega</small></span>
              </li>
              <li>
                <span class="mia-fluxo__num">3</span>
                <span><strong>Forma de pagamento</strong><small>Método e troco</small></span>
              </li>
              <li class="mia-fluxo__fim">
                <span class="mia-fluxo__num"><i class="fas fa-arrow-right"></i></span>
                <span><strong>Cardápio digital</strong><small>Cliente finaliza o pedido</small></span>
              </li>
            </ol>
          </div>

          <div class="mia-vazio" *ngIf="!configuracoes.typebotConfigurado && !criandoFluxosTypebot">
            <p>Os fluxos ainda não foram criados para esta loja.</p>
            <button type="button" class="btn btn-primary" (click)="abrirTelaConfigTypebot()">
              <i class="fas fa-cogs"></i> Ativar fluxos de conversas
            </button>
          </div>

          <div class="mia-vazio" *ngIf="criandoFluxosTypebot">
            <span class="mia-spinner"></span>
            <p>Criando os fluxos de conversas…</p>
          </div>

          <div class="mia-canais" *ngIf="configuracoes.typebotConfigurado">
            <div class="mia-canal">
              <span class="mia-canal__icone mia-canal__icone--whatsapp"><i class="fab fa-whatsapp"></i></span>
              <div class="mia-canal__texto">
                <strong>WhatsApp</strong>
                <small>Fluxo ativo neste canal</small>
              </div>
              <button type="button" class="btn btn-outline-primary btn-sm"
                      (click)="editarFluxoTypebot('whatsapp', 'WhatsApp')">Editar fluxo</button>
            </div>

            <div class="mia-canal" *ngIf="false">
              <span class="mia-canal__icone mia-canal__icone--instagram"><i class="fab fa-instagram"></i></span>
              <div class="mia-canal__texto">
                <strong>Instagram</strong>
                <small>Fluxo ativo neste canal</small>
              </div>
              <button type="button" class="btn btn-outline-primary btn-sm"
                      (click)="editarFluxoTypebot('instagram', 'Instagram')">Editar fluxo</button>
            </div>
          </div>
        </ng-container>
      </section>
    </div>

    <!-- ABA 6. Mia V3 (visível só para admins do meucardápio) -->
    <div class="mia-painel-aba" id="mia-painel-miav3" role="tabpanel" aria-labelledby="mia-aba-miav3"
         *ngIf="ehAdminMeuCardapio" [class.mia-painel-aba--oculta]="abaAtiva !== 'miav3'">

      <section class="mia-card">
        <div class="mia-card__head">
          <h2 class="mia-card__titulo">
            <span class="mia-card__icone mia-card__icone--roxo"><i class="fas fa-flask"></i></span>
            Motor Mia V3
            <span class="mia-tag" title="Visível apenas para administradores"><i class="fas fa-lock"></i> admin</span>
          </h2>
          <p class="mia-card__desc">A vendedora conversacional que assume a venda no WhatsApp oficial.</p>
        </div>

        <label class="mia-chave" for="chkUsarMiaV3" [class.mia-chave--ligada]="configuracoes.usarMiaV3">
          <span class="mia-chave__icone"><i class="fas fa-robot"></i></span>
          <span class="mia-chave__texto">
            <strong>Atender pela Mia V3</strong>
            <small>Substitui o bot antigo no WhatsApp oficial.</small>
          </span>
          <input type="checkbox" class="mia-chave__input" id="chkUsarMiaV3" name="usarMiaV3"
                 [(ngModel)]="configuracoes.usarMiaV3"/>
          <span class="mia-chave__trilho"><span class="mia-chave__botao"></span></span>
        </label>

        <label class="mia-chave" for="chkCarrinhoMiaV3" [class.mia-chave--ligada]="configuracoes.carrinhoMiaV3">
          <span class="mia-chave__icone"><i class="fas fa-shopping-cart"></i></span>
          <span class="mia-chave__texto">
            <strong>Carrinho conversacional</strong>
            <small>Monta o pedido e fecha a venda no chat. Sem ele, a Mia V3 só tira dúvidas e direciona ao cardápio.</small>
          </span>
          <input type="checkbox" class="mia-chave__input" id="chkCarrinhoMiaV3" name="carrinhoMiaV3"
                 [(ngModel)]="configuracoes.carrinhoMiaV3" (ngModelChange)="onCarrinhoMiaV3Change()"/>
          <span class="mia-chave__trilho"><span class="mia-chave__botao"></span></span>
        </label>

        <div class="mia-campo mia-campo--folga">
          <label for="modelo-ia-v3" class="mia-label mia-label--cap">Modelo de IA</label>
          <select class="form-control" id="modelo-ia-v3" name="modeloIaV3" [(ngModel)]="configuracoes.modeloIaV3">
            <option *ngFor="let modelo of modelosIa" [ngValue]="modelo.valor">{{ modelo.rotulo }}</option>
          </select>
          <p class="mia-hint">Motor inteligente responsável por interpretar dúvidas do cardápio e sugestões.</p>
        </div>

        <div class="mia-campo mia-campo--larga">
          <label for="instrucoes-da-loja" class="mia-label mia-label--cap">Instruções da loja</label>
          <textarea class="form-control" id="instrucoes-da-loja" name="instrucoesDaLoja" rows="4" maxlength="1500"
                    [(ngModel)]="configuracoes.instrucoesDaLoja"
                    placeholder="Ex.: A loja é tratada no masculino: 'o Empório', 'no Empório'. Nunca ofereça bebida alcoólica junto de pedidos de almoço."></textarea>
          <p class="mia-hint">Particularidades desta loja que a Mia deve seguir: tratamento do nome, tom regional,
            restrições de oferta. Entram no prompt como instruções de estilo — as regras de segurança
            (nunca inventar itens, preços ou prazos) continuam valendo por cima.</p>
        </div>

        <div class="mia-checklist" *ngIf="statusMiaV3">
          <div class="mia-checklist__topo">
            <div class="mia-checklist__texto">
              <span class="mia-checklist__titulo">Checklist de ativação</span>
              <span class="mia-checklist__resumo">
                {{ checklistProntos }} de {{ itensChecklistMiaV3.length }} requisitos prontos
              </span>
            </div>
            <button type="button" class="mia-checklist__recarregar" (click)="carregueStatusMiaV3()" title="Reconsultar">
              <i class="fas fa-sync-alt"></i>
            </button>
          </div>

          <div class="mia-checklist__barra" [class.mia-checklist__barra--completa]="checklistCompleto">
            <span [style.width.%]="checklistPercentual"></span>
          </div>

          <ul class="mia-checklist__lista">
            <li class="mia-checklist__item" *ngFor="let item of itensChecklistMiaV3"
                [class.mia-checklist__item--ok]="item.ok">
              <span class="mia-checklist__marca">
                <i class="fas" [ngClass]="item.ok ? 'fa-check' : 'fa-exclamation'"></i>
              </span>
              <span>
                <strong>{{ item.rotulo }}</strong>
                <small *ngIf="item.detalhe">{{ item.detalhe }}</small>
              </span>
            </li>
          </ul>

          <p class="mia-hint">O checklist reflete o que está salvo — depois de mudar os toggles, salve e reconsulte.</p>
        </div>
      </section>

      <section class="mia-card" *ngIf="statusMiaV3?.recursoMiaV3Ativo">
        <div class="mia-card__head">
          <h2 class="mia-card__titulo">
            <span class="mia-card__icone mia-card__icone--roxo"><i class="fas fa-comment-dots"></i></span>
            Widget de demonstração
          </h2>
          <p class="mia-card__desc">
            Página pública onde o cliente testa a Mia no celular, sem login — envie o link e deixe a Mia vender por você.
          </p>
        </div>

        <div class="mia-widget__linha" *ngIf="widgetUrl">
          <input class="mia-widget__url" type="text" readonly [value]="widgetUrl" (focus)="$any($event.target).select()"/>
          <button type="button" class="mia-widget__btn" (click)="copieLinkWidget()"
                  [class.mia-widget__btn--ok]="widgetCopiado">
            <i class="fas" [ngClass]="widgetCopiado ? 'fa-check' : 'fa-copy'"></i>
            {{ widgetCopiado ? 'Copiado!' : 'Copiar link' }}
          </button>
          <a class="mia-widget__btn mia-widget__btn--claro" [href]="widgetUrl" target="_blank"
             title="Abrir o widget numa aba nova">
            <i class="fas fa-external-link-alt"></i>
          </a>
        </div>

        <p class="mia-hint" *ngIf="widgetCarregando">Carregando o link…</p>
        <p class="mia-widget__erro" *ngIf="widgetErro">⚠️ {{ widgetErro }}</p>

        <div class="mia-widget__rodape" *ngIf="widgetUrl">
          <p class="mia-hint">
            Qualquer pessoa com o link conversa com a Mia usando o cardápio desta loja.
            As conversas aparecem na tela de conversas identificadas como <strong>Widget</strong>.
          </p>
          <button type="button" class="mia-link mia-link--perigo" (click)="regenereTokenWidget()"
                  [disabled]="regenerandoWidget">
            <i class="fas fa-sync-alt"></i>
            {{ regenerandoWidget ? 'Regenerando…' : 'Regenerar link (invalida o atual)' }}
          </button>
        </div>
      </section>
    </div>

    <!-- Barra de ações fixa: salvar sempre ao alcance -->
    <div class="mia-acoes">
      <div class="mia-acoes__estado">
        <span class="mia-pill" [attr.data-estado]="estadoAtual.chave">
          <span class="mia-pill__dot"></span>{{ estadoAtual.rotulo }}
        </span>
        <span class="mia-acoes__msg" *ngIf="msgSucesso"><i class="mdi mdi-check-all"></i> {{ msgSucesso }}</span>
      </div>
      <div class="mia-acoes__botoes">
        <button type="reset" class="btn btn-light">Cancelar</button>
        <button type="submit" class="btn btn-primary">Salvar alterações</button>
      </div>
    </div>
  </form>
</div>
